<template>
  <div class="about">
    <DashHeader />
    <div class="page">
      <h1>How the Trump Approval Rating Number is Determined</h1>
      <p>
        This chart shows the
        <a href="https://fivethirtyeight.com">FiveThirtyEight's</a> weighted average of approve/disapprove polls adjusted based on FiveThirtyEight’s determination of those polls’ quality, recency, sample size, and partisan lean.
      </p>

      <router-link class="page_nav_button" to="/">Back Dashboard</router-link>
    </div>
  </div>
</template>
<script>
import DashHeader from "@/components/DashHeader.vue";
export default {
  name: "AboutApproval",
  components: {
    DashHeader
  }
};
</script>
